import { AxiosRequestConfig } from "axios";
import apiClient from "./api.ts";
import { NewUser } from "@/types/base-model.ts";

interface PutPasswordInput {
    userDocId: string;
    currentPassword: string;
    newPassword: string;
}

export const getLoggedInUser = () => {
    return apiClient.get('/users/me');
};

export const putUserToDb = (data: NewUser, config: AxiosRequestConfig = {}) => {
    return apiClient.put("/userdata/me", { data }, config);
};

export const putUserpasswordToDb = (data: PutPasswordInput, config: AxiosRequestConfig = {}) => {
    return apiClient.put("/userdata/changepw", { data }, config);
};